import ApiService from "@/services/api.service";

const StaticDataService = {
  loadStaticData: async function () {
    return ApiService.post(`/ApiStaticData`, {
      body: {},
      command: "StaticData"
    });
  },
};

export default StaticDataService;
